"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclarativeCopilotCapabilityName = void 0;
/**
 * @deprecated Use capabilities from generated types instead.
 */
var DeclarativeCopilotCapabilityName;
(function (DeclarativeCopilotCapabilityName) {
    DeclarativeCopilotCapabilityName["WebSearch"] = "WebSearch";
    DeclarativeCopilotCapabilityName["GraphicArt"] = "GraphicArt";
    DeclarativeCopilotCapabilityName["CodeInterpreter"] = "CodeInterpreter";
    DeclarativeCopilotCapabilityName["OneDriveAndSharePoint"] = "OneDriveAndSharePoint";
    DeclarativeCopilotCapabilityName["GraphConnectors"] = "GraphConnectors";
    DeclarativeCopilotCapabilityName["EmbeddedKnowledge"] = "EmbeddedKnowledge";
})(DeclarativeCopilotCapabilityName || (exports.DeclarativeCopilotCapabilityName = DeclarativeCopilotCapabilityName = {}));
//# sourceMappingURL=declarativeCopilotManifest.js.map